import React, { useEffect, useState } from "react";
import { Button, Divider, makeStyles } from "@fluentui/react-components";
import { AddSquareRegular, GridRegular } from "@fluentui/react-icons";
import { useAddInStore, useTokenStore } from "../../../hooks";
import { supabaseApi } from "../../../services";

const useStyles = makeStyles({
  section: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "30px",
    padding: "0 15px",
    marginTop: "20%",
  },
  button: {
    flex: "1 auto",
    width: "100%",
  },
});

const MainViewButtons = () => {
  const styles = useStyles();

  // indicates the current user is authenticated
  const isAuthenticated = useTokenStore((state) => state.isAuthenticated);

  // indicates the selected space id
  const setCurrentView = useAddInStore((state) => state.setCurrentView);

  // indicates the current organization id
  const selectedOrganizationId = useAddInStore((state) => state.selectedOrganizationId);

  // indicates that the user can create space in the selected organization
  const [canCreateSpaces, setCanCreateSpaces] = useState<boolean>(false);

  useEffect(() => {
    if (!isAuthenticated || !selectedOrganizationId) return;

    const checkPermissions = async () => {
      try {
        const hasPermission = await supabaseApi.hasPermission(
          "organization",
          selectedOrganizationId,
          "space.INSERT"
        );
        setCanCreateSpaces(hasPermission);
      } catch (error) {}
    };

    checkPermissions();
  }, [isAuthenticated, selectedOrganizationId]);

  return (
    <section className={styles.section}>
      <Button
        className={styles.button}
        size="medium"
        appearance="primary"
        icon={<AddSquareRegular />}
        onClick={() => setCurrentView("create_space")}
        disabled={!isAuthenticated || !canCreateSpaces}
      >
        Schedule in New Space
      </Button>

      <Divider>or</Divider>

      <Button
        className={styles.button}
        size="medium"
        appearance="secondary"
        icon={<GridRegular />}
        onClick={() => setCurrentView("add_to_existing_space")}
        disabled={!isAuthenticated}
      >
        Schedule in Existing Space
      </Button>
    </section>
  );
};

export default MainViewButtons;
